import React, { InputHTMLAttributes } from "react"
import { Field, FieldRenderProps } from "react-final-form"
import InfoBox from "../boxes/InfoBox"
import Input from "../controls/Input"
import SubmitError from "./SubmitError"
import { fieldClass, fieldStyle, identity, StyledProps } from "../../utils/form";

type InputType = "date" | "number" | "text" | "email" | "password"

const parseNumber = (s: string): number | "" => {
  const n = parseFloat(s);
  return isNaN(n) ? "" : n;
}

interface TextFieldProps extends StyledProps {
  autoFocus?: boolean;
  className?: string;
  disabled?: boolean;
  disabledWithValue?: null | number | string;
  errorClass?: string;
  hasHeader?: boolean;
  hasLabel?: boolean;
  i18key?: string;
  i18nTip?: string
  id?: string;
  label?: string;
  labelClassName?: string;
  max?: number | string;
  maxErrorLengthInsideField?: number;
  min?: number | string;
  name: string;
  numeric?: boolean;
  parse?: (value: any) => any;
  required?: boolean;
  small?: boolean;
  step?: number | string;
  tightLabel?: boolean;
  type?: InputType;
  unit?: string;
}

const TextField: React.FC<TextFieldProps> = (props: TextFieldProps) => {
  const type = props.type || "text"
  const disabled = props.disabled || !!props.disabledWithValue

  return (
    <Field
      {...props}
      parse={props.parse || (type === "number" ? parseNumber : identity)}
      type={type}
      render={(renderProps: FieldRenderProps<number | string>): React.ReactNode => {
        const {
          autoFocus, className, i18key, i18nTip, id, label, labelClassName, max, meta, min,
          numeric, required, small, step, tightLabel, unit
        } = renderProps;
        const input: InputHTMLAttributes<HTMLInputElement> = props.disabledWithValue
          ? {value: props.disabledWithValue}
          : renderProps.input;
        if (numeric) {
          input.inputMode = "numeric";
          input.pattern = "[0-9]*";
        }
        return (
          <div className={fieldClass(className, !!meta.submitError)} style={fieldStyle(props)}>
            <Input
              hasHeader={props.hasHeader}
              hasLabel={props.hasLabel}
              i18key={i18key as string | undefined}
              input={{ ...input, autoFocus, disabled, id, max, min, step, required }}
              label={label}
              labelClassName={labelClassName}
              small={small}
              tightLabel={tightLabel}
              unit={unit}
            />
            <SubmitError className={props.errorClass} errors={meta.submitError}/>
            {i18nTip && <InfoBox i18nKey={i18nTip}/>}
          </div>
        )
      }}
    />
  )
}

export default TextField
